<template>
  <div class="home">

    <div class="content">
      <h2 id="title">車両一覧</h2>

      <gmap-map
        id="map"
        ref="map"
        :center="{lat: center.latitude, lng: center.longitude}"
        :zoom="15"
      >

        <!--
        <GmapInfoWindow :key="index"
                        v-for="(m, index) in markerInfos"
                        :position="{lat: m.latitude, lng: m.longitude}"
                        :options="infoOptions"
                        :opened="true" @closeclick="deleteInfoWindow(m)">
          <table>
            <tr>
              <td style="text-align:left;">
                <p>{{m.name}}</p>
                <p>{{m.time}}</p>
              </td>
            </tr>
          </table>
        </GmapInfoWindow>
        -->

        <!--
        <GmapInfoWindow :key="index + 1000"
                        v-for="(p, index) in pinInfos"
                        :position="{lat: p.latitude, lng: p.longitude}"
                        :options="infoOptions"
                        :opened="true" @closeclick="deletePinInfoWindow(p)">
          <table>
            <tr>
              <td style="text-align:left;">
                <p>id: {{p.id}}</p>
                <p>{{p.name}}</p>
                <p>to {{p.destination_name}}</p>
                <p>from {{p.client}}</p>
                <button class="button" @click="showDirectionFromPin(p)">経路</button>
              </td>
            </tr>
          </table>
        </GmapInfoWindow>
        -->


        <gmap-marker
          :key="index + markers.length + pins.length"
          v-for="(m, index) in markers"
          :position="{lat: m.latitude, lng: m.longitude}"
          :icon="{ url: getPinImagePath(m),
          scaledSize: {width: 34, height: 40}}"
          @click="toggleInfoWindow(m,index)"
        >

          <GmapInfoWindow
                          :position="{lat: m.latitude, lng: m.longitude}"
                          :options="infoOptions"
                          :opened="m.displayInfo" @closeclick="deleteInfoWindow(m)">
            <table>
              <tr>
                <td style="text-align:left;">
                  <p>{{m.name}}</p>
                  <p>{{m.time}}</p>
                </td>
              </tr>
            </table>
          </GmapInfoWindow>


        </gmap-marker>

        <gmap-marker
          :key="index + (2 * markers.length) + pins.length"
          v-for="(p, index) in pins"
          :position="{lat: p.latitude, lng: p.longitude}"
          @click="togglePinInfoWindow(p,index)"
        >
          <GmapInfoWindow
                          :position="{lat: p.latitude, lng: p.longitude}"
                          :options="infoOptions"
                          :opened="p.displayInfo" @closeclick="deletePinInfoWindow(p)">
            <table>
              <tr>
                <td style="text-align:left;">
                  <p>id: {{p.id}}</p>
                  <p>{{p.name}}</p>
                  <p>to {{p.destination_name}}</p>
                  <p>from {{p.client}}</p>
                  <button class="button" @click="showDirectionFromPin(p)">経路</button>
                </td>
              </tr>
            </table>
          </GmapInfoWindow>
        </gmap-marker>
      </gmap-map>
    </div>
  </div>

</template>

<script>
  import {db, auth, apiKey} from '../firebase'
  import moment from 'moment'
  import {Subject, Observable, combineLatest, asyncScheduler, asapScheduler} from 'rxjs'
  import axios from 'axios'
  import qs from 'querystringify'

  const isSuperResponsive = false
  const showLine = false
  const showInactiveDriver = false

  export default {
    name: 'HomeMap',

    created () {
      var _this = this

      this.timer = setInterval(this.refreshDriverPins, 60000)

      this.driverFetchSubject = new Subject()
      this.destinationFetchSubject = new Subject()
      this.mapLoadSubject = new Subject()

      this.$watch('drivers', function(value) {
        console.log('drivers changed, and position updated', value.length)

        this.needDriverPinRefresh = true

        if(isSuperResponsive){

          /*
          _this.markers = []
          var i;
          for (i = 0; i < value.length; i++) {
            let driver = value[i]

            //送迎状態のときのみ位置を表示
            if (driver.latitude && driver.longitude) {

              _this.markers.push(
                {
                  latitude: driver.latitude,
                  longitude: driver.longitude,
                  name: driver.name,
                  driver_id: driver.id,
                  time: this.positionTimeString(driver.position_time),
                  vehicleType: driver.vehicleType
                }
              )

            }
          }*/

          this.refreshDriverPins()
        }
      })


      this.$watch('orders', function(value) {
        console.log('orders changed, and position updated', value.length)


        //オーダーの状態が変わって、配送中でないドライバーが出てくる可能性があるので、ここでもneedDriverPinRefreshをtrueにする。
        this.needDriverPinRefresh = true


        _this.pins = []

        var newPinList = []
        var newPinsWithInfo = {}
        var i;
        for (i = 0; i < value.length; i++) {
          let order = value[i].data()
          if (order.destination_latitude && order.destination_longitude) {

            //ディスプレイ表示中のマーカーの情報を引き継ぐ処理
            let newDisplayInfo = false
            let displayInfo = _this.pinsWithInfo[order.id] || false
            if(displayInfo === true){
              let visibleMapBounds = this.$refs.map.$mapObject.getBounds() //vue2-google-mapオブジェクトからGoogle Mapオブジェクトを取得する必要がある。
              let isInfoWindowInTheMapBounds = visibleMapBounds.contains(
                new google.maps.LatLng(order.destination_latitude, order.destination_longitude)
              )
              if(!isInfoWindwInTheMapBounds){
                console.log("closing this marker info for the order", order.id)
              }else{
                console.log("keep showing this marker info for the order", order.id)
                newDisplayInfo = true
                newPinsWithInfo[driver.id] = newDisplayInfo
              }
            }

            newPinList.push(
              {
                latitude: order.destination_latitude,
                longitude: order.destination_longitude,
                destination_name: order.destination_name,
                client: order.client,
                driver_id: order.driver_id,
                name: order.name,
                id: value[i].id,
                displayInfo: newDisplayInfo
              }
            )
            console.log('order pushed', value[i].id, order)
            //let bounds  = new google.maps.LatLngBounds();
          }
        }
        _this.pins = newPinList //forループのなかでpushすると、そのたびにMapがリロードされてしまうので、ループ後に一気にリストを代入する
        _this.pinsWithInfo = newPinsWithInfo //ディスプレイ表示中のマーカーの情報を引き継ぐ
      })
    },


    data () {
      return {
        orders: [],
        drivers: [],

        center: { latitude: 45.508, longitude: -73.587 },
        markers: [],
        pins: [],

        //markerInfos: [],
        //pinInfos: [],

        markersWithInfo: {},
        pinsWithInfo: {},


        infoOptions: {
          flag: false,
          pixelOffset: {
            width: 0,
            height: -5
          }
        },


        perPage: 150,
        currentPage: 1, //最初のページは1 (0ではない)

        isFirstOrderShown: true,
        isLastOrderShown: false,

        driverFetchSubject: null,
        destinationFetchSubject: null,
        mapLoadSubject: null,

        isAutoZoomDoneOnce: false,
        needDriverPinRefresh: false,

        subscription: null,

        timer: null
      }
    },

    computed: {

      paginationInfo (){
        let idx = this.currentPage - 1
        let from = idx * this.perPage + 1
        let to = from + this.orders.length - 1
        return `${from} -  ${to}`
      },

      leftArrowSrc() {
        if(this.isFirstOrderShown) {
          return require("@/assets/arrow_left_inactive@2x.png")
        }else{
          return require("@/assets/arrow_left_active@2x.png")
        }
      },

      rightArrowSrc() {
        if(this.isLastOrderShown){
          return require("@/assets/arrow_right_inactive@2x.png")
        }else{
          return require("@/assets/arrow_right_active@2x.png")
        }
      },

      position: function () {
        self = this;
        return function (order) {
          let tracking = order['tracking']

          if(tracking != null){
            let position = tracking['position']
            if(position != null){
              return position.latitude + ", " +  position.longitude
            }
          }
          return "";
        };
      },

      trackingDatetime: function () {
        self = this;
        return function (order) {
          let tracking = order['tracking']
          if(tracking != null){
            let date = tracking['datetime'].toDate()
            return moment(date).format('YYYY/MM/DD HH:mm')
          }
          return ""
        };
      },

      orderCreatedDatetime: function () {
        self = this;
        return function (order) {
          let createdAt = order['createdAt']
          if(createdAt != null){
            let date = createdAt.toDate()
            return moment(date).format('YYYY/MM/DD HH:mm')
          }
          return ""
        };
      },

      companyId() {
        let coId = this.$store.getters.companyId
        if(coId){
          return coId
        }

        //localStorageに存在したらそれをVuexのstoreに書き込んでリターンする。
        if (localStorage.companyId) {
          this.$store.commit('setCompanyId', localStorage.companyId)
          return localStorage.companyId
        }
      },

    },


    methods: {

      positionTimeString (position_time) {
        if(position_time != null){
          let date = position_time.toDate()
          return moment(date).format('YYYY/MM/DD HH:mm')
        }
        return ''
      },

      //docの配列を取得（dataの配列ではない）
      async fetchNextOrders() {

        try {
          let querySnapshot
          if(this.orders.length > 0){
            querySnapshot = await db.collection('companies').doc(this.companyId).collection('orders').where("status", "==", "started").orderBy("createdAt", "desc").startAfter(this.orders[this.orders.length - 1]).limit(this.perPage).get()
          }else{
            querySnapshot = await db.collection('companies').doc(this.companyId).collection('orders').where("status", "==", "started").orderBy("createdAt", "desc").limit(this.perPage).get()
          }

          if(querySnapshot.size > 0){
            console.log("querySnapshot", querySnapshot);
            if(this.orders.length === 0){
              this.isFirstOrderShown = true
              this.currentPage = 1
            }else{
              this.isFirstOrderShown = false
              this.currentPage++
            }
            this.orders = querySnapshot.docs

            if(this.orders.length < this.perPage){
              this.isLastOrderShown = true
            }

            console.log('fetchNextOrders onNext()')


            this.destinationFetchSubject.next()
          }else{
            console.log("No such order");
            this.isLastOrderShown = true
          }
        }catch(error){
          console.log("Error while fetching next orders", error);
        }
      },


      async fetchPreviousOrders() {
        //これを参考にした
        //https://stackoverflow.com/a/54075453/1709287
        try {
          if(this.orders.length > 0){

            //sortOrderを逆さまにすることで、今一番まえのものより、perPageだけ前にいる要素をstartAfterで取り出せる。
            let querySnapshot = await db.collection('companies').doc(this.companyId).collection('orders').orderBy("createdAt", "asc").startAfter(this.orders[0]).limit(this.perPage).get()

            if(querySnapshot.size > 0){
              console.log("querySnapshot", querySnapshot);

              //sort order = ascになっていて、逆順になっているので、reverse()してdesc順に戻す
              this.orders = querySnapshot.docs.reverse()

              this.isLastOrderShown = false
              this.currentPage--

              if(this.currentPage === 1){
                this.isFirstOrderShown = true
              }
            }else{
              console.log("No such order");
              this.isFirstOrderShown = true
            }
          }
        }catch(error){
          console.log("Error while fetching previous orders", error);
        }
      },


      getDrivers () {
        let self = this

        this.$bind('drivers', db.collection('companies').doc(this.companyId).collection('drivers')).then(drivers => {
          console.log("getDrivers done", drivers)
          //this.getDrivers(orders, self)

          self.driverFetchSubject.next()
        })
      },

      getDriverName(driverId) {
        if(driverId == null){
          return null
        }else{
          let chosenDriver = this.drivers.find(driver => driver.id === driverId)
          if(chosenDriver != null){
            return chosenDriver.name
          }else{
            return null
          }
        }
      },

      rowClicked(orderDoc) {
        console.log('order pushed', orderDoc.id)
        this.$router.push({ name: 'OrderDetail', params: { id: orderDoc['id'] }})

      },

      loadNextOrders() {
        //this.updateOrders()
        this.fetchNextOrders()
      },

      loadPreviousOrders() {
        this.fetchPreviousOrders()
      },

      deleteInfoWindow (marker) {
        marker.displayInfo = false
        this.markersWithInfo[marker.driver_id] = marker.displayInfo

        /*
        let index = -1
        for (let i = 0; i < this.markerInfos.length; i++) {
          if(this.markerInfos[i].driver_id === marker.driver_id){
            index = i
            break
          }
        }

        //let index = this.markerInfos.indexOf(marker)
        if(index > -1){
          console.log("deleting marker info (before)" + this.markerInfos.length)
          this.markerInfos.splice(index, 1);
          console.log("deleting marker info (after)" + this.markerInfos.length)
        }
        */
      },

      deletePinInfoWindow (pin) {
        pin.displayInfo = false
        this.pinsWithInfo[pin.id] = pin.displayInfo

        /*
        let index = -1
        for (let i = 0; i < this.pinInfos.length; i++) {
          if(this.pinInfos[i].id === pinInfo.id){
            index = i
            break
          }
        }

        //let index = this.pinInfos.indexOf(marker)
        if(index > -1){
          this.pinInfos.splice(index, 1);
        }
        */
      },

      toggleInfoWindow (marker, idx) {

        marker.displayInfo = !marker.displayInfo

        this.markersWithInfo[marker.driver_id] = marker.displayInfo
        //console.log("markersWithInfo", this.markersWithInfo)

        /*

        let index = -1
        for (let i = 0; i < this.markerInfos.length; i++) {
          if(this.markerInfos[i].driver_id === marker.driver_id){
            index = i
            break
          }
        }

        //let index = this.markerInfos.indexOf(marker)
        if(index > -1){
          console.log("deleting marker info (before)" + this.markerInfos.length)
          this.markerInfos.splice(index, 1);
          console.log("deleting marker info (after)" + this.markerInfos.length)
        }else{
          console.log("opening")
          this.markerInfos.push(marker)
        }
        */
      },

      togglePinInfoWindow (pin, idx) {

        pin.displayInfo = !pin.displayInfo

        this.pinsWithInfo[pin.id] = pin.displayInfo
        //console.log("pinsWithInfo", this.pinsWithInfo)

        /*
        let index = -1
        for (let i = 0; i < this.pinInfos.length; i++) {
          if(this.pinInfos[i].id === pinInfo.id){
            index = i
            break
          }
        }

        //let index = this.pinInfos.indexOf(marker)
        if(index > -1){
          this.pinInfos.splice(index, 1);
        }else{
          this.pinInfos.push(pinInfo)
        }
        */
      },

      getPinImagePath(marker) {
        if(marker.vehicleType){
          if(marker.vehicleType === "bike"){
            return require("@/assets/bike_pin@2x.png")
          }else{
            return require("@/assets/driver_pin@2x.png")
          }
        }else{
          return require("@/assets/driver_pin@2x.png")
        }
      },

      drawLines() {
        console.log("drawLines")

        const data$ = new Observable((observer) => {
          var pathOfPath = [];
          console.log('lenght of drivers ' +  this.drivers.length);
          console.log('lenght of orders ' +  this.orders.length);

          for (let i = 0; i < this.drivers.length; i++) {
            let driver = this.drivers[i]

            for (let j = 0; j < this.orders.length; j++) {
              let order = this.orders[j].data()
              let orderId = this.orders[j].id
              var path = [];

              if(driver.id === order.driver_id){
                if (driver.latitude && driver.longitude) {
                  if (order.destination_latitude && order.destination_longitude) {

                    console.log('order - driver matched', orderId, driver);

                    path.push(new google.maps.LatLng(driver.latitude, driver.longitude))
                    path.push(new google.maps.LatLng(order.destination_latitude, order.destination_longitude))
                    pathOfPath.push(path)
                  }
                }
              }
            }
          }

          console.log('send path of ' + pathOfPath);
          observer.next(pathOfPath);
          observer.complete();
        });

        let map = this.$refs.map

        let subscriptionOfPath = data$
          .subscribeOn(asyncScheduler)
          .observeOn(asapScheduler)
          .subscribe({
            next(pathes) {

              for (let i = 0; i < pathes.length; i++) {
                var path = pathes[i]

                var line = new google.maps.Polyline({
                  path: path,
                  strokeColor: "#4988FF",
                  strokeOpacity: 0.75,
                  strokeWeight: 2,
                  geodesic: true
                });


                line.setMap(map.$mapObject);
              }

              console.log('got path of ' + pathes.length);

              },
            error(err) { console.error('something wrong occurred: ' + err); },
            complete() {
              console.log('done');
              subscriptionOfPath.unsubscribe()
            }
          })
      },

      showDirectionFromPin(pin) {
        console.log("showDirectionFromPin")

        const data$ = new Observable((observer) => {
          console.log('lenght of drivers ' +  this.drivers.length);
          console.log('lenght of orders ' +  this.orders.length);

          console.log('pin is ', pin)

          let driver_id = pin.driver_id

          for (let j = 0; j < this.drivers.length; j++) {

            let driver = this.drivers[j]

            if(driver_id === driver.id){
              console.log('driver is ', driver)
              if (driver.latitude && driver.longitude) {
                let path = [];
                path.push(new google.maps.LatLng(driver.latitude, driver.longitude))
                path.push(new google.maps.LatLng(pin.latitude, pin.longitude))

                console.log('onSend: Received path' + path[0] + "," +  path[1])

                observer.next(path);
              }
            }
            //console.log('a path is pushed. length of pathOf Path is ' + pathOfPath.length);
          }

          //console.log('send path of ' + path);
          observer.complete();
        });

        let map = this.$refs.map

        let subscriptionOfPath = data$
          .subscribeOn(asyncScheduler)
          .observeOn(asapScheduler)
          .subscribe({
            next(path) {

              console.log('onNext: Received path' + path[0] + "," +  path[1])


              //google maps API's direction service
              function calculateAndDisplayRoute(map, directionsService, start, destination) {
                directionsService.route({
                  origin: start,
                  destination: destination,
                  travelMode: 'DRIVING'
                }, function(response, status) {
                  if (status === 'OK') {
                    var directionsDisplay = new google.maps.DirectionsRenderer(
                      {
                        suppressMarkers: true
                      });
                    directionsDisplay.setMap(map);
                    directionsDisplay.setDirections(response);

                    console.log('Have drawn the direction path', start, destination)
                  } else {
                    window.alert('Directions request failed due to ' + status);
                  }
                });
              }

              var directionsService = new google.maps.DirectionsService;


              calculateAndDisplayRoute(map.$mapObject, directionsService, path[0], path[1]);


            },
            error(err) { console.error('something wrong occurred: ' + err); },
            complete() {
              console.log('done');
              subscriptionOfPath.unsubscribe()
            }
          })
      },

      refreshDriverPins() {
        console.log('refreshDriverPins')

        if(this.needDriverPinRefresh){
          console.log('refreshDriverPins does actual refresh')


          var newMarkerList = []
          var newMarkersWithInfo = {}


          for (let i = 0; i < this.orders.length; i++) {
            let order = this.orders[i].data()
            let orderId = this.orders[i].id

            for (let j = 0; j < this.drivers.length; j++) {
              let driver = this.drivers[j]


              if(driver.id === order.driver_id && order.status === "started"){
                //送迎状態のときのみ位置を表示
                if (driver.latitude && driver.longitude) {


                  //ディスプレイ表示中のマーカーの情報を引き継ぐ処理
                  let newDisplayInfo = false
                  let displayInfo = this.markersWithInfo[driver.id] || false
                  if(displayInfo === true){
                    console.log("*display info is true: ", driver.id)
                    let visibleMapBounds = this.$refs.map.$mapObject.getBounds()
                    let isInfoWindowInTheMapBounds = visibleMapBounds.contains(
                      new google.maps.LatLng(driver.latitude, driver.longitude)
                    )
                    if(!isInfoWindowInTheMapBounds){
                      console.log("closing this marker info for the driver", driver.id)
                    }else{
                      console.log("*keep showing this marker info for the driver", driver.id)
                      newDisplayInfo = true
                      newMarkersWithInfo[driver.id] = newDisplayInfo
                    }
                  }
                  newMarkerList.push(
                    {
                      latitude: driver.latitude,
                      longitude: driver.longitude,
                      name: driver.name,
                      driver_id: driver.id,
                      time: this.positionTimeString(driver.position_time),
                      vehicleType: driver.vehicleType,
                      displayInfo: newDisplayInfo
                    }
                  )
                }
                break
              }
            }
          }

          this.markers = newMarkerList //ここではじめてMapがリロードされる。forループのなかでmarkersにpushされるとその都度Mapがリロードされてしまう。
          this.markersWithInfo = newMarkersWithInfo //ディスプレイ表示中のマーカーの情報を引き継ぐ

          //ここはマップ描画時にも同じ処理があるので、Observableで対応したい。
          if(this.isAutoZoomDoneOnce === false){
            let bounds  = new google.maps.LatLngBounds();

            var j;
            for (j = 0; j < this.markers.length; j++) {
              let locDriver = new google.maps.LatLng(this.markers[j].latitude, this.markers[j].longitude);
              bounds.extend(locDriver);
            }

            console.log('auto zoom (first time)', bounds)
            this.$refs.map.fitBounds(bounds);       //auto-zoom
            this.$refs.map.panToBounds(bounds);       // auto-center



            this.isAutoZoomDoneOnce = true
          }

          this.needDriverPinRefresh = false

        }

      },


      refreshToken(){

        /*
        var bodyFormData = new FormData();
        bodyFormData.set('grant_type', 'refresh_token');
        bodyFormData.set('refresh_token', auth.currentUser.refreshToken);
        */

        const requestBody = {
          grant_type: 'refresh_token',
          refresh_token: auth.currentUser.refreshToken,
        }
        const requestBodyString = qs.stringify(requestBody,"")
        console.log('form:', requestBodyString)

        let config = {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          }
        };


        let url = 'https://securetoken.googleapis.com/v1/token?key=' + apiKey

        axios.post(url, requestBodyString, config)
          .then(function (response) {
            //handle success
            console.log(response);
          })
          .catch(function (response) {
            //handle error
            console.log(response.message);
          });

        /*
        console.log('refreshToken starts')
        auth.currentUser.getIdToken()
          .then(function (idToken) {
            console.log('newToken', idToken);
          }).catch(function (error) {
          console.log('refreshToken error:', error);
        })
        */
      }
    },


    filters: {
      moment: function (date) {
        return moment(date).format('YYYY/MM/DD HH:mm');
      }
    },

    mounted () {

      this.$nextTick(function () {
        // ビュー全体がレンダリングされた後にのみ実行されるコード
        /* マップオブジェクトを取得(mountedでやると、まだthis.$refs.mapがnull */
        if(this.$refs.map != null){
          console.log("map is not null");

          var _this = this
          this.$refs.map.$mapPromise.then((map) => {


            /*
            if(this.markers.length > 1){

              let bounds  = new google.maps.LatLngBounds();

              var i;
              for (i = 0; i < this.markers.length; i++) {
                let locDriver = new google.maps.LatLng(this.markers[i].latitude, this.markers[i].longitude);
                bounds.extend(locDriver);
              }

              if(this.isAutoZoomDoneOnce === false){
                console.log('auto zoom (first time)', bounds)
                map.fitBounds(bounds);       //auto-zoom
                map.panToBounds(bounds);       // auto-center

                this.isAutoZoomDoneOnce = true
              }

            }else{
              if(this.markers.length > 0){
                this.center = {lat: this.markers[0].latitude, lng: this.markers[0].longitude}
                console.log('move to driver', this.center)
              }
            }
            */



            _this.mapLoadSubject.next()
            console.log('combine: mapLoadSubject onNext')
          })
        }else{
          console.log("map is null");
        }

      })


      if(!this.companyId){
        this.$router.push('/signin')
      }else{
        //this.getOrders()
        this.fetchNextOrders()
        this.getDrivers()

        let _this = this
        this.subscription = combineLatest(this.driverFetchSubject, this.destinationFetchSubject, this.mapLoadSubject).subscribe(
          () => {
            console.log('combineLatest')

            if(showLine){
              _this.drawLines()
            }

            this.refreshDriverPins()

          }
        );
      }
    },

    beforeDestroy () {
      clearInterval(this.timer)
    }
  }
</script>

<style scoped>
  .home {
    width: 100%;
    height: 100vh;
    background-color: #F3F3F3;

  }

  .content {
    width: 94%;
    margin-left:auto;
    margin-right:auto;
    padding-bottom: 80px;
  }


  .clearfix:after {
    content: "";
    display: block;
    clear: both;

  }

  #title {
    margin: 63px 0 0 0;
    color: #5C5C5C;
    font-weight: normal;
    font-size: 30px;
  }

  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }

  #map {
    width: 100%;
    height: 680px;
    margin-top: 10px;
  }

  .button {
    text-align: center;
    margin-top: 2px;
    margin-bottom: 2px;
    padding: 7px 10px 7px 10px;
    font-size: 15px;
  }


  /* iPad対応 */
  @media (max-width: 768px){
    .content {
      width: 100%;
      margin-left:auto;
      margin-right:auto;
      padding-bottom: 20px;
    }

    #title {
      margin: 20px 0 0 27px;
      color: #5C5C5C;
      font-weight: bold;
      font-size: 21px;
    }
    #map {
      height: 800px;
    }
  }

  /* スマホ対応 */
  @media (max-width: 400px){
    #map {
      height: 600px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/HomeMap.vue